import { ClientInferResponseBody } from "@ts-rest/core";

import { api, contract } from "#app/http/api";

type Params = {
  email: string;
  password: string;
};

type LoginResponse = ClientInferResponseBody<typeof contract.auth.login>;

export const loginService = async (user: Params): Promise<LoginResponse | null> => {
  const response = await api.auth.login.mutation({ body: user });

  if (response.status === 201) {
    return response.body;
  }

  if (response.status === 401) {
    throw new Error("Invalid Credentials");
  }

  throw new Error("Error while login");
};
